import React from 'react';
import { Button } from '@lightspeed/flame/Button';
import Checkbox from '@lightspeed/cirrus-checkbox';
import { Divider } from '@lightspeed/flame/Divider';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';

const STORAGE_HIDE_MODAL = 'HIDE_PUBLISH_TO_ECOM_MODAL';

export default class PublishToEcomModal extends React.Component {
  /**
   * Get the sessionStorage key
   * @returns {String}
   */
  static get STORAGE_HIDE_MODAL() {
    return STORAGE_HIDE_MODAL;
  }

  constructor(props) {
    super(props);

    this.state = {
      showModal: true,
      dontShowAgain: false,
    };

    this.close = this.close.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deleteItemFromEcom = this.deleteItemFromEcom.bind(this);
  }

  handleChange(event) {
    this.setState({ dontShowAgain: event.target.checked });
  }

  /**
   * Action when closing the modal
   */
  close() {
    this.setState(
      {
        showModal: false,
      },
      () => {
        // In case the animation end was not triggered
        setTimeout(() => {
          this.props.renderedComponent.unmount();
        }, 250);
      }
    );
  }

  /**
   * When the Delete button is clicked, a sessionStorage key will be written if the
   * option was checked and the item's "publish_to_ecom" value will be resetted & saved
   */
  deleteItemFromEcom() {
    if (this.state.dontShowAgain) {
      sessionStorage.setItem(STORAGE_HIDE_MODAL, true);
    }

    this.props.PublishToEcom.unpublishItem();

    this.close();
  }

  /**
   * Render the Installing modal
   * @returns {Object} DOM Element
   */
  render() {
    const { dontShowAgain } = this.state;

    return (
      <Modal
        className="publish-to-ecom cirrus"
        isOpen={this.state.showModal}
        onRequestClose={this.close}
      >
        <ModalHeader onCloseClicked={this.close}>
          Delete <var>{this.props.description}</var> from eCom?
        </ModalHeader>
        <ModalBody>
          <div className="modal-container" style={{ width: '552px' }}>
            <h1>WARNING!</h1>
            <div className="cr-text-s">
              <p className="cr-m-0">
                All <strong>item information entered in eCom</strong> will be deleted.
              </p>
              <p className="cr-m-0">
                Sales and reporting information <strong>will be preserved</strong>.
              </p>
              <p className="cr-m-0">
                This action is <strong>destructive</strong> and <strong>can not be undone</strong>.
              </p>
            </div>
            <Divider className="cr-pv-4" />
            <div className="cr-text-right">
              <Checkbox
                checked={dontShowAgain}
                onChange={this.handleChange}
                label="Don&#39;t show this warning until next time I log in."
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Group className="cr-justify-end">
            <Button onClick={this.close}>Cancel</Button>
            <Button variant="danger" fill onClick={this.deleteItemFromEcom}>
              I understand the consequences. Delete from eCom.
            </Button>
          </Group>
        </ModalFooter>
      </Modal>
    );
  }
}
